import { captureException } from '@sentry/core'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { first, sortBy } from 'lodash-es'
import { z } from 'zod'

import { eveningTeamsQuery } from '@/state/regions/regions'

const eveningMessagesSearchSchema = z.object({
  regionName: z.string().optional(),
  piloteRegionId: z.number().optional(),
  eveningDate: z.string().optional(),
  regionId: z.string().optional(),
})

export const Route = createFileRoute('/regions/messages/$eveningId/')({
  validateSearch: eveningMessagesSearchSchema,
  beforeLoad: async ({ context, params, search }) => {
    const eveningId = Number(params.eveningId)

    const { data: teams } = await context.queryClient.fetchQuery(eveningTeamsQuery(eveningId))

    const sortedTeams = sortBy(teams, (team) => Number(team.number) || Infinity)
    const firstTeamWithUnread = sortedTeams.find((team) => team.messagingStatus?.hasUnreadTeamMessages)
    const currentTeam = firstTeamWithUnread ?? first(sortedTeams)

    if (!currentTeam) {
      throw redirect({
        to: '/regions',
        replace: true,
      })
    }

    throw redirect({
      to: '/regions/messages/$eveningId/$teamId',
      from: Route.fullPath,
      params: {
        eveningId: params.eveningId,
        teamId: currentTeam._id,
      },
      search: {
        regionName: search.regionName,
        piloteRegionId: search.piloteRegionId,
        eveningDate: search.eveningDate,
        regionId: search.regionId,
      },
      replace: true,
    })
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
